import { MiddlewareAPI } from "@/lib/axios";
import { NetworkMethodEnum, Obj } from "@/types/common";

export const mutator = async (
  method: NetworkMethodEnum,
  url: string,
  data?: Obj
) => {
  const res = await MiddlewareAPI({
    method,
    url,
    data,
  });
  return res.data;
};
